import MarkdownRenderer from "../markdown/MarkdownRenderer";

const AIMessage = ({ content }) => {
    if (!content) return
    return (<div className="ai-message" style={{ width: '90%', maxWidth: '90%', display: 'flex', gap: '.3rem', padding: '1rem' }}>
        <div className="ai-msg-avatar">
            <p >AI</p>
        </div>
        <div style={{ borderRadius: '1rem', display: 'flex', flexDirection: 'column', gap: '.4rem', padding: '1rem 1rem', backgroundColor: 'var(--lightestGrey)' }}>
            <MarkdownRenderer>
                {content?.replace(/(\[.*?\])/g, "$1\n").replace('<think>', '<p>').replace('</think>', '</p>')}
            </MarkdownRenderer>
        </div>
    </div>)
}

export default AIMessage

// ?.replace(/(\[.*?\])/g, "$1\n").replace('<thinking>', '').replace('</thinking>', '')}